<template>
  <div class="p-series" :class="{'p-series--black': seriesBlack}" v-if="currentItem">
    <!-- MV -->
    <div class="p-series__mv">
      <div id="c-modelMv" class="c-modelMv">
        <div class="c-modelMv__thumb">
          <picture>
            <source media="(max-width: 900px)" :srcset="`${$store.getters.assetsPath}${currentItem.mv.src.sp}`" />
            <img :src="`${$store.getters.assetsPath}${currentItem.mv.src.pc}`" alt="" width="1420" height="940" />
          </picture>
        </div>
        <div class="c-modelMv__info">
          <h2>
            <span>{{currentItem.mv.info.name[0]}}</span>
            <span v-if="$store.getters.lang === 'ja'">{{currentItem.mv.info.name[1]}}</span>
          </h2>
          <h1>
            <span>{{currentItem.mv.info.series}}</span>
            <span>series</span>
          </h1>
          <p v-html="currentItem.mv.info.text"></p>
        </div>
      </div>
    </div>

    <!-- MODELS -->
    <div class="p-series__list">
      <div id="c-modelList" class="c-modelList">
        <ul class="c-modelList__models">
          <!-- Model -->
          <li v-for="(model, index) in currentItem.list">
            <div class="c-modelBox" :class="`c-modelBox--${model.detail.length} is-select-${model.initial}`">
              <span class="c-modelBox__bg"></span>
              <div class="c-modelBox__slide" :class="{'swiper': model.detail.length > 1}" :data-init-slide="model.initial">
                <ul class="swiper-wrapper">
                  <li v-for="d in model.detail" class="swiper-slide"><img :src="`${$store.getters.assetsPath}${d.src}`" alt="" width="400" height="160" /></li>
                </ul>
                <div class="is-btnLeft swiper-button-prev"></div>
                <div class="is-btnRight swiper-button-next"></div>
              </div>
              <div class="c-modelBox__info">
                <h2>{{model.name}}</h2>
                <div>
                  <p v-for="d in model.detail">
                   <span>{{d.spec.color}}</span>
                   <template v-if="d.spec.price !== ''">希望小売価格 ￥{{d.spec.price}}（税込）<br /></template>
                   <template v-if="$store.getters.lang === 'en'">[SIZE]</template><template v-else>【サイズ】</template>{{d.spec.size}}<br />
                   <template v-if="$store.getters.lang === 'en'">[LENS HEIGHT]</template><template v-else>【レンズ天地幅】</template>{{d.spec.lens}}<br />
                   <template v-if="$store.getters.lang === 'en'">[FRAME WIDTH]</template><template v-else>【枠幅】</template>{{d.spec.frame}}
                  </p>
                </div>
                <hr />
                <dl class="is-color" :class="`is-max-${model.detail.length}`">
                  <dt>Color:</dt>
                  <dd>
                    <ul>
                      <li 
                      v-for="(d, i) in model.detail" 
                      @click="changeColor(index, i)"
                      :style="{'backgroundColor':`#${d.color}`}"></li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="currentItem.note" class="c-modelList__note">
          <p>{{currentItem.note}}</p>
        </div>
      </div>
    </div>

    <div class="p-series__exLink">
      <a 
      class="c-btnEx c-btnEx--ex" 
      :href="currentItem.link_catalogue" 
      target="_blank" 
      @click="$store.commit('sendGA', {action: 'click', path: '', label: 'バナー - その他のモデルはこちら'});">
      <template v-if="$store.getters.lang === 'en'">VIEW OTHER MODELS</template><template v-else>その他のモデルはこちら</template>
    </a>
    </div>

    <!-- dignity -->
    <div v-if="currentItem.dignity" class="p-series__gallery is-dignity">
      <div class="c-gallery">
        <div class="c-gallery__text">
          <span></span>
        </div>
        <div class="c-gallery__head">
          <h2>
            <span>Dignity</span>
          </h2>
          <p v-if="$store.getters.lang === 'ja'">程よい重量感と品格のある質感</p>
          <p v-else>DIGNITY AND EXCLUSIVE QUALITY</p>
        </div>
        <div class="c-gallery__photo">
          <img 
          v-for="(img, i) in currentItem.dignity" 
          class="is-photo" 
          :class="`is-photo${i+1}`" 
          :src="`${$store.getters.assetsPath}${img}`" alt="">
        </div>
      </div>
    </div>

    <!-- comfortable -->
    <div v-if="currentItem.comfortable" class="p-series__gallery is-comfortable">
      <div class="c-gallery">
        <div class="c-gallery__text">
          <span></span>
        </div>
        <div class="c-gallery__head">
          <h2>
            <span>Comfortable</span>
          </h2>
          <p v-if="$store.getters.lang === 'ja'">理想的なフレームバランス</p>
          <p v-else>IDEAL FRAME BALANCE</p>
        </div>
        <div class="c-gallery__photo">
          <img 
          v-for="(img, i) in currentItem.comfortable" 
          class="is-photo" 
          :class="`is-photo${i+1}`" 
          :src="`${$store.getters.assetsPath}${img}`" alt="">
        </div>
      </div>
    </div>

    <!-- natural material -->
    <div v-if="currentItem.natural" class="p-series__gallery is-natural">
      <div class="c-gallery">
        <div class="c-gallery__text">
          <span></span>
        </div>
        <div class="c-gallery__head">
          <h2>
            <span>Natural Material</span>
          </h2>
          <p v-if="$store.getters.lang === 'ja'">天然素材ならではの美しさ</p>
          <p v-else>BEAUTY FROM NATURAL MATERIAL</p>
        </div>
        <div class="c-gallery__photo">
          <img 
          v-for="(img, i) in currentItem.natural" 
          class="is-photo" 
          :class="`is-photo${i+1}`" 
          :src="`${$store.getters.assetsPath}${img}`" alt="">
        </div>
      </div>
    </div>

    <!-- harmony -->
    <div v-if="currentItem.harmony" class="p-series__gallery is-harmony">
      <div class="c-gallery">
        <div class="c-gallery__text">
          <span></span>
        </div>
        <div class="c-gallery__head">
          <h2>
            <span>Harmony</span>
          </h2>
          <p v-if="$store.getters.lang === 'ja'">質感と機能性の調和</p>
          <p v-else>HARMONIZATION OF QUALITY AND FUNCTIONALITY</p>
        </div>
        <div class="c-gallery__photo">
          <img 
          v-for="(img, i) in currentItem.harmony" 
          class="is-photo" 
          :class="`is-photo${i+1}`" 
          :src="`${$store.getters.assetsPath}${img}`" alt="">
        </div>
      </div>
    </div>

    <!-- one and only -->
    <div v-if="currentItem.one" class="p-series__gallery is-one">
      <div class="c-gallery">
        <div class="c-gallery__text">
          <span></span>
        </div>
        <div class="c-gallery__head">
          <h2>
            <span>One and only</span>
          </h2>
          <p v-if="$store.getters.lang === 'ja'">唯一無二の質感</p>
          <p v-else>UNIQUE TEXTURE</p>
        </div>
        <div class="c-gallery__photo">
          <img 
          v-for="(img, i) in currentItem.one" 
          class="is-photo" 
          :class="`is-photo${i+1}`" 
          :src="`${$store.getters.assetsPath}${img}`" alt="">
        </div>
      </div>
    </div>

    <!-- fusion -->
    <div v-if="currentItem.fusion" class="p-series__gallery is-fusion">
      <div class="c-gallery">
        <div class="c-gallery__text">
          <span></span>
        </div>
        <div class="c-gallery__head">
          <h2>
            <span>Fusion</span>
          </h2>
          <p v-if="$store.getters.lang === 'ja'">美しさと快適さの融合</p>
          <p v-else>THE PERFECT BLEND OF AESTHETIC QUALITY AND COMFORT</p>
        </div>
        <div class="c-gallery__photo">
          <img 
          v-for="(img, i) in currentItem.fusion" 
          class="is-photo" 
          :class="`is-photo${i+1}`" 
          :src="`${$store.getters.assetsPath}${img}`" alt="">
        </div>
      </div>
    </div>
    
    <!-- 商品 -->
    <div class="p-series__prod">
      <lineup></lineup>
    </div>
  </div>
</template>

<script>
import Lineup from '@/_components/Lineup';
import Swiper, { Navigation } from 'swiper';
import { gsap, Quart } from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// gsap
gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

export default {
  components: {
    Lineup,
  },
  data() {
    return {
      dataID: null,
      currentItem: null,
      swipers: [],
      ScrollSmoother: null,
      ispc: false,
      scrollObjects: [],
      resizeObserver: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 初期設定
      vm.once(to.name);
    });
  },
  beforeRouteLeave(to, from, next) {
    // loading表示
    this.$store.commit('setShowLoad', true);
    
    setTimeout(() => {
      this.reset();
      next();
    }, this.$store.getters.loadTime * 1000);
  },
  beforeRouteUpdate (to, form, next) {
    next();
  },
  computed: {
    seriesBlack() {
      return this.$store.getters.seriesBlack;
    },
  },
  mounted() {
  },
  methods: {
    once(toName){
      this.dataID = toName;
      if (toName === 'g20' 
      || toName === 'en_g20') {
        this.$store.commit('setSeriesBlack', true);
        this.$store.commit('setHeadBlack', true);
      } else {
        this.$store.commit('setSeriesBlack', false);
        this.$store.commit('setHeadBlack', false);
      }

      if (toName.indexOf('en_') > -1) {
        // 英語版
        this.currentItem = this.$store.getters.getItemEnAll[toName.replace('en_', '')];
      } else {
        this.currentItem = this.$store.getters.getItemAll[toName];
      }

      this.resizeObserver = new ResizeObserver(this.resize);
      this.resizeObserver.observe(document.body);
      this.$nextTick(this.start);

      this.$emit('child-ready', '準備完了');
    },
    start() {
      this.$store.commit('setShowLoad', false);

      this.resize();

      document.querySelectorAll('.swiper').forEach((el, index) => {

        const initID = parseInt(el.getAttribute('data-init-slide'), 10);
        const s = new Swiper(el, {
          modules: [Navigation],
          initialSlide: initID - 1,
          slidesPerView: 1,
          speed: 500,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            init: function (e) {
              // console.log('swiper initialized', e);
            },
            slideChangeTransitionStart: function(e) {
              if (!e.initialized) return;
              const classRemove = `is-select-${e.previousIndex}`;
              e.$el[0].parentNode.classList.remove(classRemove);
              const classAdd = `is-select-${e.realIndex + 1}`;
              e.$el[0].parentNode.classList.add(classAdd);
            },
          },
        });

        this.swipers.push(s);
      });
    },
    setting() {
      let triggers = ScrollTrigger.getAll();
      triggers.forEach(function (trigger) {
          trigger.kill();
      });

      //if (gFNS.isDevice === 'pc') {
        //////////
        // gsap SmoothScroller
        //////////
        this.ScrollSmoother = ScrollSmoother.create({
          effects: false,
          smooth: 1,
          smoothTouch: 0.1,
          ignoreMobileResize: true,
          normalizeScroll: true,
          //onUpdate: this.scroll,
        });
      //}

      //////////
      // gsap ScrollTrigger
      //////////
      ScrollTrigger.normalizeScroll(true);

      // ヘッダー
      ScrollTrigger.create({
        trigger: '#c-modelList',
        start: 'top top',
        scrub: true,
        ease: 'none',
        onToggle: (self) => {
          if (this.$store.getters.seriesBlack) return;
          if (self.isActive || self.direction === 1) {
            this.$store.commit('setHeadBlack', true);
          } else {
            this.$store.commit('setHeadBlack', false);
          }
        },
      });

      // MV 
      this.scrollObjects.push('.c-modelMv__thumb');
      const tlmv = gsap.timeline();
      tlmv.to('.c-modelMv__thumb', {y: '50%', ease: 'none'});

      ScrollTrigger.create({
        animation: tlmv,
        trigger: '#c-modelMv',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        ease: 'none',
      });

      // gallery text
      this.scrollObjects.push('.c-gallery__text');
      document.querySelectorAll('.c-gallery__text').forEach((el, i) => {
        gsap.set(el, {
          scrollTrigger: {
            trigger: el,
            start: 'top center+=20%',
            scrub: true,
            once: true,
            toggleClass: 'c-gallery__text--toggle',
          }
        });
      });

      // gallery img
      this.scrollObjects.push(`.c-gallery__photo > img`);
      document.querySelectorAll('.c-gallery__photo > img').forEach((el, i) => {
        gsap.set(el, {
          scrollTrigger: {
            trigger: el,
            start: 'top center+=20%',
            scrub: true,
            once: true,
            toggleClass: 'is-photo-show',
          }
        });
      });

      // LINE UP
      this.scrollObjects.push('.c-product__text');

      gsap.set('.c-product__text', {
        scrollTrigger: {
          trigger: '.c-product__text',
          start: 'top center+=20%',
          scrub: true,
          once: true,
          toggleClass: 'c-product__text--toggle',
        }
      });
    },
    changeColor(swiperID, colorID) {
      this.swipers[swiperID].slideTo(colorID + 1);
    },
    settingPC() {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    },
    settingSP() {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    },
    resize() {
      if (this.checkSP(900)) {
        // sp
        if (this.ispc) {
          this.ispc = false;
          this.settingSP();
        }
      } else {
        // pc
        if (!this.ispc) {
          this.ispc = true;
          this.settingPC();
        }
      }

      this.setting();
    },
    checkSP(breakpoint) {
      return window.matchMedia('(max-width: ' + breakpoint +'px)').matches;
    },
    reset() {
      // console.log('series reset', this.scrollObjects);
      
      this.resizeObserver.unobserve(document.body);
      this.resizeObserver.disconnect();

      if (this.ScrollSmoother) {
        this.ScrollSmoother.scrollTo(0, 0);
        this.ScrollSmoother.kill();
        this.ScrollSmoother = null;
        window.scrollTo(0, 0);
      }

      let triggers = ScrollTrigger.getAll();
      triggers.forEach(function (trigger) {
          trigger.kill();
      });

      this.scrollObjects.forEach((el) => {
        gsap.set(el, {clearProps: true});
      });
      this.scrollObjects = [];

      if (this.swipers.length) {
        this.swipers.forEach((swp) => {
          swp.destroy();
        });
        this.swipers = [];
      }

      this.$store.commit('setHeadBlack', false);
      this.currentItem = null;
    }
  }
}
</script>